import type { RealtorProspect } from '../types/activity'

export const realtorProspects: RealtorProspect[] = [
  {
    id: 'RP-101',
    name: 'Danielle Ortiz',
    company: 'Summit & Co. Realty',
    market: 'North Metro',
    stage: 'first-touch',
    source: 'Listing post engagement',
    phone: '(612) 555-0148',
    email: 'dortiz@summitco.com',
    touches: 3,
    lastTouchDaysAgo: 0,
    listingsPerYear: 24,
    note: 'Posts every new listing on Instagram. Warm to co-marketing.',
  },
  {
    id: 'RP-102',
    name: 'Andre Whitfield',
    company: 'Keystone Group',
    market: 'Lakeside',
    stage: 'conversation',
    source: 'Open house drop-by',
    phone: '(612) 555-0192',
    email: 'andre@keystonegrp.com',
    touches: 6,
    lastTouchDaysAgo: 2,
    listingsPerYear: 31,
    note: 'Unhappy with current lender’s communication. Asked about weekend pre-quals.',
  },
  {
    id: 'RP-103',
    name: 'Sonia Bhatt',
    company: 'Bhatt Property Group',
    market: 'North Metro',
    stage: 'meeting-set',
    source: 'Referral from Priya Raman',
    phone: '(612) 555-0110',
    email: 'sonia@bhattpg.com',
    touches: 8,
    lastTouchDaysAgo: 1,
    listingsPerYear: 42,
    note: 'Coffee Thursday 8:30 AM. Bring first-time-buyer program one-pager.',
  },
  {
    id: 'RP-104',
    name: 'Tyler Nguyen',
    company: 'Urban Key Realty',
    market: 'Downtown',
    stage: 'researching',
    source: 'MLS top-producer list',
    phone: '(612) 555-0177',
    email: 'tyler@urbankey.com',
    touches: 0,
    lastTouchDaysAgo: null,
    listingsPerYear: 19,
    note: 'Condo-heavy book. Needs a lender comfortable with non-warrantable.',
  },
  {
    id: 'RP-105',
    name: 'Megan Cole',
    company: 'Cole Realty Partners',
    market: 'West Suburbs',
    stage: 'referring',
    source: 'Open house co-host',
    phone: '(612) 555-0165',
    email: 'megan@colerp.com',
    touches: 14,
    lastTouchDaysAgo: 9,
    listingsPerYear: 27,
    note: 'Sent first referral last month. Ready to graduate to My Realtors.',
  },
  {
    id: 'RP-106',
    name: 'Grant Fielder',
    company: 'Northline Realty',
    market: 'Lakeside',
    stage: 'first-touch',
    source: 'Social DM',
    phone: '(612) 555-0134',
    email: 'grant@northline.com',
    touches: 2,
    lastTouchDaysAgo: 14,
    listingsPerYear: 15,
    note: 'Replied to a market-update comment. No call connected yet.',
  },
  {
    id: 'RP-107',
    name: 'Rosa Delgado',
    company: 'Delgado Homes',
    market: 'South Metro',
    stage: 'conversation',
    source: 'Chamber event',
    phone: '(612) 555-0155',
    email: 'rosa@delgadohomes.com',
    touches: 5,
    lastTouchDaysAgo: 21,
    listingsPerYear: 22,
    note: 'Bilingual buyer base. Wants Spanish-language pre-approval letters.',
  },
]

export const prospectStageMeta: Record<
  RealtorProspect['stage'],
  { label: string; classes: string }
> = {
  researching: {
    label: 'Researching',
    classes: 'bg-navy-50 text-navy-600 ring-navy-200',
  },
  'first-touch': {
    label: 'First touch',
    classes: 'bg-brand-50 text-brand-700 ring-brand-200',
  },
  conversation: {
    label: 'In conversation',
    classes: 'bg-teal-50 text-teal-700 ring-teal-200',
  },
  'meeting-set': {
    label: 'Meeting set',
    classes: 'bg-warn-50 text-warn-700 ring-warn-200',
  },
  referring: {
    label: 'Referring',
    classes: 'bg-success-50 text-success-700 ring-success-200',
  },
}
